var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { createSelector } from '@reduxjs/toolkit';
import axios, { HttpStatusCode } from 'axios';
import { t } from 'i18next';
import { useCallback, useEffect, useMemo } from 'react';
import { useAuthStrategy } from '../../authentication';
import { useUserSessionAPI } from '../../components/app/selectors';
import { useAppDispatch, useAppSelector } from '../hooks';
import { fetchFailed, fetchReset, fetchStart, fetchSuccess } from './reducer';
export var CHALLENGE_STATUS = 'challengeStatus';
/**
 * A 502 is the ALB telling us our own task died or answered badly, so no usable body.
 * A 504 is either the ALB giving up, or our API reporting that a vendor timed out, which
 * carries a message naming what to change. "Try again" is bad advice for that one, a retry fails the
 * same way. Hence keying off the body rather than the status
 */
export var resolveGatewayError = function (data, busyError) {
  var message = data === null || data === void 0 ? void 0 : data.message;
  return typeof message === 'string' && message.length > 0 ? data : busyError;
};
var apiSelector = function (state) {
  return state.api;
};
var defaultData = {};
var createDataSelector = function (key) {
  return createSelector(apiSelector, function (api) {
    var _a;
    return (_a = api[key]) !== null && _a !== void 0 ? _a : defaultData;
  });
};
export var substituteParams = function (str, params) {
  return params !== undefined ? Object.keys(params).reduce(function (current, key) {
    var _a;
    return current.replace(new RegExp("{".concat(key, "}|:").concat(key)), "".concat((_a = params[key]) !== null && _a !== void 0 ? _a : ''));
  }, str) : str;
};
/** Keys that appear as path placeholders in the URL template, e.g. {id} or :id */
function getPathParamKeys(urlTemplate) {
  var keys = [];
  var brace = /\{(\w+)\}/g;
  var colon = /:(\w+)(?=[/?#]|$)/g;
  var m;
  while ((m = brace.exec(urlTemplate)) !== null) keys.push(m[1]);
  while ((m = colon.exec(urlTemplate)) !== null) keys.push(m[1]);
  return Array.from(new Set(keys));
}
var APIClient = /** @class */function () {
  function APIClient(authStrategy, url, key, method, responseType, contentType) {
    this.authStrategy = authStrategy;
    this.url = url;
    this.key = "".concat(key, ":").concat(method);
    this.method = method;
    this.responseType = responseType;
    this.contentType = contentType;
  }
  APIClient.prototype.getKey = function () {
    return this.key;
  };
  APIClient.prototype.abort = function (state) {
    var abortController = (state.api[this.key] || {}).abortController;
    abortController === null || abortController === void 0 ? void 0 : abortController.abort();
  };
  APIClient.prototype.resetState = function () {
    var _this = this;
    return function (dispatch, getState) {
      _this.abort(getState());
      dispatch(fetchReset({
        key: _this.key
      }));
    };
  };
  APIClient.prototype.request = function (options) {
    var _this = this;
    return function (dispatch, getState) {
      return __awaiter(_this, void 0, void 0, function () {
        var abortController, requestOptions, _a, pathParams_1, restOptions, pathKeys_1, pathOnly, paramsForUrl, url, queryParamKeys, queryParams, _b, data, statusCode, e_1, internalError, busyError, _c, data, statusCode, error, _d, _e, __1;
        var _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
          switch (_l.label) {
            case 0:
              if (!this.url) return [2 /*return*/];
              this.abort(getState());
              abortController = new AbortController();
              dispatch(fetchStart({
                key: this.key,
                abortController: abortController
              }));
              _l.label = 1;
            case 1:
              _l.trys.push([1, 3,, 11]);
              requestOptions = this.authStrategy.getRequestOptions();
              _a = options !== null && options !== void 0 ? options : {}, pathParams_1 = _a.params, restOptions = __rest(_a, ["params"]);
              pathKeys_1 = getPathParamKeys(this.url);
              pathOnly = pathParams_1 !== undefined && pathKeys_1.length > 0 ? pathKeys_1.reduce(function (acc, k) {
                var _a;
                return pathParams_1[k] !== undefined && pathParams_1[k] !== null ? __assign(__assign({}, acc), (_a = {}, _a[k] = pathParams_1[k], _a)) : acc;
              }, {}) : {};
              paramsForUrl = Object.keys(pathOnly).length > 0 ? pathOnly : pathParams_1;
              url = pathParams_1 !== undefined && Object.keys(pathParams_1).length > 0 ? substituteParams(this.url, paramsForUrl) : this.url;
              queryParamKeys = pathParams_1 === undefined ? [] : Object.keys(pathParams_1).filter(function (k) {
                return !pathKeys_1.includes(k);
              });
              queryParams = pathParams_1 !== undefined && queryParamKeys.length > 0 ? queryParamKeys.reduce(function (acc, k) {
                var _a;
                return __assign(__assign({}, acc), (_a = {}, _a[k] = pathParams_1[k], _a));
              }, {}) : undefined;
              return [4 /*yield*/, axios(__assign(__assign(__assign(__assign({
                url: url,
                method: this.method,
                signal: abortController.signal,
                responseType: this.responseType
              }, requestOptions), restOptions), queryParams !== undefined && Object.keys(queryParams).length > 0 && {
                params: queryParams
              }), {
                headers: __assign(__assign({}, requestOptions.headers), {
                  'Content-Type': (_f = this.contentType) !== null && _f !== void 0 ? _f : (_g = requestOptions.headers) === null || _g === void 0 ? void 0 : _g['Content-Type']
                })
              }))];
            case 2:
              _b = _l.sent(), data = _b.data, statusCode = _b.status;
              dispatch(fetchSuccess({
                key: this.key,
                data: data,
                statusCode: statusCode
              }));
              return [3 /*break*/, 11];
            case 3:
              e_1 = _l.sent();
              internalError = {
                message: t('error.internalError')
              };
              busyError = {
                message: t('error.busyError')
              };
              if (!axios.isCancel(e_1)) return [3 /*break*/, 4];
              return [3 /*break*/, 10];
            case 4:
              if (!axios.isAxiosError(e_1)) return [3 /*break*/, 9];
              _c = (_h = e_1.response) !== null && _h !== void 0 ? _h : {}, data = _c.data, statusCode = _c.status;
              error = data || internalError;
              if (statusCode === HttpStatusCode.Unauthorized) {
                this.authStrategy.onUnauthorized();
                return [2 /*return*/, dispatch(fetchReset({
                  key: this.key
                }))];
              }
              if (statusCode === HttpStatusCode.Gone || statusCode === HttpStatusCode.PreconditionFailed) {
                window.dispatchEvent(new StorageEvent('storage', {
                  key: CHALLENGE_STATUS,
                  newValue: statusCode.toString()
                }));
                return [2 /*return*/, dispatch(fetchReset({
                  key: this.key
                }))];
              }
              if (statusCode === HttpStatusCode.BadGateway || statusCode === HttpStatusCode.GatewayTimeout) {
                error = resolveGatewayError(data, busyError);
              }
              if (statusCode === HttpStatusCode.InternalServerError) {
                error = internalError;
              }
              if (!(this.responseType === 'blob')) return [3 /*break*/, 8];
              _l.label = 5;
            case 5:
              _l.trys.push([5, 7,, 8]);
              _e = (_d = JSON).parse;
              return [4 /*yield*/, (_k = (_j = e_1.response) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.text()];
            case 6:
              error = _e.apply(_d, [_l.sent()]);
              return [3 /*break*/, 8];
            case 7:
              __1 = _l.sent();
              return [3 /*break*/, 8];
            case 8:
              dispatch(fetchFailed({
                key: this.key,
                error: error,
                statusCode: statusCode
              }));
              return [3 /*break*/, 10];
            case 9:
              console.error(e_1);
              dispatch(fetchFailed({
                key: this.key,
                error: internalError
              }));
              _l.label = 10;
            case 10:
              return [3 /*break*/, 11];
            case 11:
              return [2 /*return*/];
          }
        });
      });
    };
  };
  return APIClient;
}();
export var useAPI = function (url, substitutions, method, _a) {
  if (substitutions === void 0) {
    substitutions = {};
  }
  if (method === void 0) {
    method = 'GET';
  }
  var _b = _a === void 0 ? {} : _a,
    _c = _b.responseType,
    responseType = _c === void 0 ? 'json' : _c,
    _d = _b.key,
    key = _d === void 0 ? url : _d,
    contentType = _b.contentType;
  var dispatch = useAppDispatch();
  var substitutedUrl = substituteParams(url, substitutions);
  var substitutedKey = substituteParams(key, substitutions);
  var authStrategy = useAuthStrategy();
  var client = useMemo(function () {
    return new APIClient(authStrategy, substitutedUrl, substitutedKey, method, responseType, contentType);
  }, [authStrategy, substitutedUrl, substitutedKey, method, responseType, contentType]);
  var doRequest = useCallback(function (data, params) {
    return dispatch(client.request({
      data: data,
      params: params
    }));
  }, [client, dispatch]);
  var dataKey = client.getKey();
  var dataSelector = useMemo(function () {
    return createDataSelector(dataKey);
  }, [dataKey]);
  var data = useAppSelector(function (state) {
    return dataSelector(state);
  });
  var resetStateAPI = useCallback(function () {
    return dispatch(client.resetState());
  }, [client, dispatch]);
  return [data, doRequest, resetStateAPI];
};
export var useCachedAPI = function (url, substitutions, method, options) {
  if (substitutions === void 0) {
    substitutions = {};
  }
  if (method === void 0) {
    method = 'GET';
  }
  if (options === void 0) {
    options = {};
  }
  var _a = useAPI(url, substitutions, method, options),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var fetchDataWrapper = useCallback(function (force) {
    if (force || data.requesting === undefined) {
      fetchData();
    }
  }, [data.requesting, fetchData]);
  return [data, fetchDataWrapper, clearData];
};
export var useAuthenticatedAPI = function (url, substitutions, method, options) {
  if (substitutions === void 0) {
    substitutions = {};
  }
  if (method === void 0) {
    method = 'GET';
  }
  if (options === void 0) {
    options = {};
  }
  var _a = useAPI(url, substitutions, method, options),
    data = _a[0],
    fetchData = _a[1],
    clearData = _a[2];
  var _b = useUserSessionAPI(),
    fetchUserSession = _b[1];
  useEffect(function () {
    if (data.statusCode === HttpStatusCode.Forbidden) {
      fetchUserSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.statusCode]);
  return [data, fetchData, clearData];
};